import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BulkAssetLinkComponent } from './bulk-asset-link/bulk-asset-link.component';
import { BulkAssetLandingComponent } from './bulk-asset-landing/bulk-asset-landing.component';

const routes: Routes = [
  {
    path: '', component: BulkAssetLinkComponent,
    children: [
      { path: 'printBulkBuildingAssetQRDetail', component: BulkAssetLandingComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BulkAssetRoutingModule { }
